export default ({ request }) => ({
  userLoanRequestListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/loan/request/list',
      method: 'post',
      data,
    })
  },
  userLoanRequestSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/loan/request/save',
      method: 'post',
      data,
    })
  },
  userLoanRequestDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/loan/request/detail',
      method: 'post',
      data,
    })
  },
  userLoanRequestDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/loan/request/del',
      method: 'post',
      data,
    })
  },
  userLoanRequestSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/user/loan/request/apply',
      method: 'post',
      data,
    })
  },
})
